
import { EnumProductTypeQuery } from '@xt/client/enums'
import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator'

export const Progressing = 'progressing'

@Component
export default class PageView extends Vue {
  @Prop() offsetTop: number
  @Prop({ default: 298 }) calendarHeight: number
  tabs = Object.freeze([
    {
      id: 1,
      title: '学习中',
      type: Progressing
    },
    {
      id: 2,
      title: '系列课',
      type: EnumProductTypeQuery.Course
    },
    {
      id: 3,
      title: '专题课',
      type: EnumProductTypeQuery.SpecialCourse
    },
    {
      id: 4,
      title: '教练日课',
      type: EnumProductTypeQuery.DayCourse
    },
    {
      id: 6,
      title: '自习课',
      type: EnumProductTypeQuery.SelfStudy
    },
    {
      id: 5,
      title: '暄桐展览',
      type: EnumProductTypeQuery.Exhibition
    }
  ])
  activeItem = this.tabs[0]
  isSticky = false

  @Ref('study-tab')
  studyTab: HTMLDivElement

  get EnumProductTypeQuery() {
    return EnumProductTypeQuery
  }

  get Progressing() {
    return Progressing
  }

  @Emit('change')
  changeTabIndex(item: any) {
    if (item.id === this.activeItem.id) return

    this.activeItem = item

    this.isSticky = false
    this.studyTab.style.removeProperty('top')
    const targetDis = 0
    window.scrollTo({ top: targetDis, behavior: 'smooth' })

    return this.activeItem
  }

  onScroll() {
    if (this.offsetTop) return
    if (window.scrollY >= 10 + this.calendarHeight + 46) {
      this.isSticky = true
    } else {
      this.isSticky = false
    }
  }

  @Watch('offsetTop')
  changeOffsetTop(value: number) {
    if (value === 0) {
      this.studyTab.style.removeProperty('top')
      return
    }
    if (this.isSticky) {
      this.studyTab.style.top = this.$px2rem(166 - value)
    }
  }

  created() {
    this.$nextTick(() => {
      document.addEventListener('scroll', this.onScroll)
    })
  }
  mounted() {}
  updated() {}
  destroyed() {
    document.removeEventListener('scroll', this.onScroll)
  }
}
